import React, { useEffect, useRef, useState } from "react";
import headerLogo from "../../assets/images/shifara-white-logo.png";
import GradientBtn from "./GradientBtn";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import WebGlobalSearch from "./WebGlobalSearch";
import arabicFlag from "../../assets/images/website-images/arabic-lang-flag.png";
import accountIcon from "../../assets/images/website-images/account.png";
import cartIcon from "../../assets/images/website-images/cart.png";
import heartIcon from "../../assets/images/website-images/heart.png";
import PrimaryBtn from "../GlobalComponents/primaryBtn";
import BrandHoverdTab from "./BrandHoverdTab";
import OnlinePharmacyHoveredTab from "./OnlinePharmacyHoveredTab";
import HealthPackageHoveredTab from "./HealthPackageHoveredTab";
import HomeCareHoveredTab from "./HomeCareHoveredTab";
import ConsultADoctorHoveredTab from "./ConsultADoctorHoveredTab";
import LabTestHoveredTab from "./LabTestHoveredTab";
import ChangeAddressModal from "../Modals/ChangeAddressModal";
import { HealthPackage, IAddressData } from "src/types/GlobalInterfaces";
import {
  getShippingAddresses,
  handleGetSelectedAddress,
  printAddress,
  checkAnyRedDot,
  fetchChatList,
} from "src/helpers/helperFunctions";
import WhishlistDrawer from "../Drawer/WhishlistDrawer";
import AccountDrawer from "../Drawer/AccountDrawer";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import ManageCartDrawer from "../Drawer/ManageCartDrawer";
import LanguageChangeModal from "../Modals/LanguageChangeModal";
import askAiIcon from "../../assets/images/AskAi/ask-ai-logo-dark.png";
import AskAi from "../AskAI/AskAi";
import { setCurrentAddress } from "src/Store/cartSlice";
import { tooglePleaseLogin } from "src/Store/reducer";
import { ImageBaseUrl } from "src/lib/constans";
import RedDotCircle from "../RedDotCircle";
import defaultProfileImage from "src/assets/images/default_profile_image.png";
import defaultProfileImage2 from "src/assets/images/website-images/default-profile.jpg";
import MeetingConversion from "../AskAI/MeetingConversion";
import TalkingAvator from "../AskAI/TalkingAvator";

const WebsiteHeader: React.FC = () => {
  const { isLogged, userDetails, unreadNotificationCount, messageUnreadCount } =
    useSelector((state: RootState) => state.appReducer);
  const { cartItems } = useSelector((store: RootState) => store.cart);
  const navigate = useNavigate();
  const [showChangeAddressModal, setShowChangeAddressModal] = useState(false);
  const [showCartDrawer, setShowCartDrawer] = useState(false);
  const [showWhishlistDrawer, setShowWhishlistDrawer] = useState(false);
  const [showAccountDrawer, setShowAccountDrawer] = useState(false);
  const [showLanguageChangeModal, setShowLanguageChangeModal] = useState(false);
  const [activeLineConfig, setActiveLineConfig] = useState<{
    left: number;
    width: number;
    show: boolean;
    targetTab: string;
  }>({
    left: 0,
    width: 0,
    show: false,
    targetTab: "",
  });
  const { diagnosticProducts, pharmacyProducts } = useSelector(
    (store: RootState) => store.cartSlice
  );
  const { allIndicators } = useSelector((state: RootState) => state.redDots);
  const { latestChat } = useSelector((state: RootState) => state.chat);
  const dispatch = useDispatch();
  const mainTabsRef = useRef<HTMLDivElement>(null);
  const handleMouseEnter = (
    e: React.MouseEvent<HTMLDivElement>,
    tab?: string,
    id?: string
  ) => {
    if (mainTabsRef.current) {
      const tabsLeft = mainTabsRef.current.getBoundingClientRect().left;
      const target = e.currentTarget;
      const left = target.getBoundingClientRect().left;
      const width = target.getBoundingClientRect().width;
      let ViewContainer = document.getElementById(id || "");
      if (ViewContainer) {
        ViewContainer.scrollIntoView({
          behavior: "auto",
          block: "nearest",
          inline: "center",
        });
      }
      if (tab) {
        setActiveLineConfig((prev) => ({
          ...prev,
          left: left - tabsLeft,
          width: width,
          show: true,
          targetTab: tab,
        }));
      } else {
        setActiveLineConfig((prev) => ({
          ...prev,
          show: true,
        }));
      }
    }
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    setActiveLineConfig((prev) => ({
      ...prev,
      show: false,
    }));
  };

  const handleClickLogin = () => {
    navigate("/login");
  };

  const TopTabs = [
    // {
    //   name: "العربية",
    //   id: "arabic-lang-btn",
    //   icon: arabicFlag,
    //   onclick: () => setShowLanguageChangeModal(true),
    // },
    {
      name: "Account",
      id: "account-btn",
      icon: accountIcon,
      isCustomImage: isLogged,
      customImage: (
        <img
          src={userDetails?.profileImageUrl}
          // alt="account"
          className="2xl:w-[30px] w-[19px] aspect-square  -translate-y-0.5  object-cover rounded-full border border-white"
          onError={(e) => {
            e.currentTarget.src = defaultProfileImage2;
          }}
        />
      ),
      // customImage: <img src={ userDetails?.profileImageUrl} alt="account" className="2xl:w-[30px] w-[21px] aspect-square 2xl:-translate-y-1  object-cover rounded-full border border-white" />,
      onclick: () => setShowAccountDrawer(true),
      count:
        checkAnyRedDot(
          allIndicators,
          latestChat,
          userDetails?.userRole || ""
        ) || unreadNotificationCount
          ? 1
          : 0,
      showCount: false,
    },
    {
      name: "Wishlist",
      id: "wishlist-btn",
      icon: heartIcon,
      onclick: () => {
        if (isLogged) {
          setShowWhishlistDrawer(true);
        } else {
          dispatch(tooglePleaseLogin(true));
        }
      },
    },
    {
      name: "Cart",
      id: "cart-btn",
      icon: cartIcon,
      onclick: () => setShowCartDrawer(true),
      count: isLogged
        ? cartItems?.length
        : diagnosticProducts?.length + pharmacyProducts?.length,
      showCount: true,
    },
  ];

  const HomeMainTabs = [
    {
      name: "Brands",
      targetTab: "brands",
      id: "brands-hovered-tab",
    },
    {
      name: "Online Pharmacy",
      targetTab: "online-pharmacy",
      id: "online-pharmacy-hovered-tab",
    },
    {
      name: "Health Packages",
      targetTab: "health-packages",
      id: "health-packages-hovered-tab",
    },
    {
      name: "Home Care",
      targetTab: "home-care",
      id: "home-care-hovered-tab",
    },
    {
      name: "Consult a Doctor",
      targetTab: "consult-a-doctor",
      id: "consult-a-doctor-hovered-tab",
    },
    {
      name: "Lab Tests",
      targetTab: "lab-tests",
      id: "lab-tests-hovered-tab",
    },
  ];

  const { address } = useSelector((store: RootState) => store.cartSlice);
  const [allHomeCareCategories, setAllHomeCareCategories] = useState<
    { name: string; image: string; id: string }[]
  >([]);
  const [homeCareCategoryLoader, setHomeCareCategoryLoader] =
    useState<boolean>(false);
  const [allTests, setAllTests] = useState<any[]>([]);
  const [allTestsLoader, setAllTestsLoader] = useState<boolean>(false);
  const [allMainCategory, setAllMainCategory] = useState<any[]>([]);
  const [allSubCategory, setAllSubCategory] = useState<any[]>([]);
  const [allChildCategory, setAllChildCategory] = useState<any[]>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [allSpecialists, setAllSpecialists] = useState<any[]>([]);
  const [specialistLoader, setSpecialistLoader] = useState<boolean>(false);
  const [activeMainCategory, setActiveMainCategory] = useState<string>("");
  const [activeSubCategory, setActiveSubCategory] = useState<string>("");
  const [healthPackages, setHealthPackages] = useState<HealthPackage[]>([]);
  const [isAskAiModalOpen, setIsAskAiModalOpen] = useState<boolean>(false);
  // Get All Brands ===============
  const [brandStates, setBrandStates] = useState<{
    loader: boolean;
    allBrands: {
      _id: string;
      brandName: string;
      brandLogo: string;
      [key: string]: any;
    }[];
  }>({
    loader: false,
    allBrands: [],
  });

  const fetchBrands = async () => {
    setBrandStates((prev) => ({ ...prev, loader: true }));
    const { res, err } = await httpRequest<{
      documents: {
        _id: string;
        brandName: string;
        brandLogo: string;
        [key: string]: any;
      }[];
    }>({ path: "/brand/home/getallbrands" });
    if (res) {
      const _data = res?.documents || [];
      setBrandStates((prev) => ({ ...prev, allBrands: _data }));
    } else {
      toast(err, { type: "error" });
    }
    setBrandStates((prev) => ({ ...prev, loader: false }));
  };

  useEffect(() => {
    fetchBrands();
    fetchChatList({ dispatch });
  }, []);

  useEffect(() => {
    const fetchSelectedAddress = async () => {
      const selectedAddress = await handleGetSelectedAddress();
      dispatch(setCurrentAddress(selectedAddress ?? null));
    };

    if (isLogged) {
      fetchSelectedAddress();
    } else {
      const addr = getShippingAddresses();
      dispatch(setCurrentAddress(addr || null));
    }
  }, [isLogged, dispatch]);

  return (
    <header
      className="sticky top-0 left-0 w-full z-20"
      id="main-website-header-container"
    >
      {/* <AskAi
        setIsAskAiModalOpen={setIsAskAiModalOpen}
        showModal={isAskAiModalOpen}
        userDetails={userDetails}
      /> */}
      <button
        className="ask-ai-btn fixed bottom-0 right-0 m-4 font-size-14px font-Poppins-Medium px-4 py-2"
        onClick={() => setIsAskAiModalOpen(true)}
      >
        <img src={askAiIcon} alt="magic-wound-icon" />
        <p className="font-size-18px">Ask AI</p>
      </button>
      {isAskAiModalOpen && (
        <div className="fixed top-0 left-0 bg-black/60 w-full h-full z-[99900] flex items-center justify-center">
          <div className="w-[80%] max-w-[1500px] h-[95%] max-h-[900px] rounded-lg lg:rounded-[1vw] relative">
            <div className="w-full h-full  overflow-y-auto">
              <TalkingAvator onClose={() => setIsAskAiModalOpen(false)} />
            </div>
          </div>
        </div>
      )}
      {showChangeAddressModal && (
        <ChangeAddressModal
          onClose={(address) => {
            setShowChangeAddressModal(false);
          }}
          activeAddress={null}
        />
      )}

      {showLanguageChangeModal && (
        <LanguageChangeModal
          onClose={() => setShowLanguageChangeModal(false)}
        />
      )}

      <WhishlistDrawer
        isOpen={showWhishlistDrawer}
        onClose={() => setShowWhishlistDrawer(false)}
      />

      <ManageCartDrawer
        isOpen={showCartDrawer}
        onClose={() => setShowCartDrawer(false)}
      />

      <AccountDrawer
        isOpen={showAccountDrawer}
        onClose={() => setShowAccountDrawer(false)}
        tab={"Account"}
        onSelectAddress={(address) => {
          // setCurrentAddress(address);
        }}
      />

      <div className="relative w-full fex flex-col">
        {/* Home First Row */}
        <div className="theme-gradient-green w-full">
          <div className="view-area-width mx-auto flex justify-between items-center 2xl:py-4 py-3">
            <div className="w-[20%]">
              <Link to={`/`} id="shifara-logo-link">
                <img
                  alt="logo"
                  className="w-[100px] lg:w-[8.6vw]"
                  src={headerLogo}
                />
              </Link>
            </div>
            <div className="flex flex-1">
              <WebGlobalSearch context="website" className="w-[89%]" />
            </div>
            <div className="w-[20%] flex justify-end gap-5">
              {TopTabs.map((tab, index) => (
                <div
                  key={"Top Tab" + index}
                  className="flex flex-col cursor-pointer items-center justify-center gap-[2px] text-white"
                  onClick={tab.onclick}
                  id={tab.id}
                >
                  <div className="2xl:h-[25px] h-[16px] relative">
                    {tab.isCustomImage ? (
                      tab.customImage
                    ) : (
                      <img
                        src={tab.icon}
                        alt={tab.name}
                        className="2xl:h-[25px] h-[16px]"
                      />
                    )}
                    {tab.count ? (
                      <RedDotCircle
                        count={tab.count}
                        placement="top-right"
                        showCount={tab.showCount}
                      />
                    ) : null}
                  </div>
                  <span className="font-size-12px mb-[-2px] font-Poppins-Medium">
                    {tab.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* HOme Second Row */}
        <div className="w-full theme-bg-green-dark">
          <div className="view-area-width mx-auto py-1 xl:py-1.5 flex justify-between items-center">
            <p className="font-size-15px font-Poppins-Regular text-white">
              For Better Shopping Experience{" "}
              <span
                className="font-Poppins-Medium cursor-pointer underline text-hover-yellow"
                onClick={() => {}}
              >
                Download Shifara App
              </span>
            </p>
            <div className="flex gap-5 items-center">
              <p className="font-size-15px font-Poppins-Regular text-white">
                <span className="font-Poppins-Medium">DELIVER TO:</span>{" "}
                {printAddress(address)}
              </p>
              <PrimaryBtn
                id="change-address-btn"
                ButtonText="Change"
                btnExtralClasses="bg-white border border-gray-600 font-Poppins-Regular font-size-14px !text-[#00443F]"
                fontFamily="font-Poppins-Medium"
                fontSize="font-size-14px"
                btnExtraStyle={{
                  padding: "4px 20px",
                  fontWeight: "400",
                }}
                onPress={() => setShowChangeAddressModal(true)}
              />
            </div>
          </div>
        </div>

        {/* Home Third Row */}
        <div className="w-full bg-white shadow-lg border-b-2 border-gray-300">
          <div className="view-area-width mx-auto flex justify-between items-center relative">
            <div
              className="flex gap-[2%] lg:gap-[4%] xl:gap-[5.7%] relative"
              ref={mainTabsRef}
            >
              {/* Hover Active Line */}
              <div
                className="absolute bottom-0 h-[2px] bg-gray-600"
                style={{
                  left: activeLineConfig.left,
                  width: activeLineConfig.width,
                  visibility: activeLineConfig.show ? "visible" : "hidden",
                  transition: "all 0.2s ease-in-out",
                }}
              ></div>
              {HomeMainTabs.map((tab, index) => (
                <div
                  id={tab.name}
                  key={"Home Main Tab" + index}
                  className="font-size-18px 2xl:py-4 py-2 font-Lexend-Regular flex items-center justify-center gap-1 categories-text-color cursor-pointer"
                  onMouseEnter={(e) =>
                    handleMouseEnter(e, tab.targetTab, tab.id)
                  }
                  onMouseLeave={(e) => handleMouseLeave(e)}
                >
                  <span className="whitespace-nowrap">{tab.name}</span>
                  <FontAwesomeIcon
                    icon={faChevronUp}
                    size="sm"
                    className={`${
                      activeLineConfig.targetTab === tab.targetTab &&
                      activeLineConfig.show
                        ? ""
                        : "rotate-180"
                    } transition-all duration-200`}
                  />
                </div>
              ))}
            </div>
            <GradientBtn
              ButtonText="Upload Prescription"
              extraClass={""}
              fontfamilyBtn="font-Poppins-Medium"
              fontsizeBtn="font-size-14px"
              onPress={() => {
                if (isLogged) {
                  navigate("/upload-prescription");
                } else {
                  dispatch(tooglePleaseLogin(true));
                }
              }}
            />
          </div>
        </div>
        {/* Tabs Dropdown  */}
        <div
          className={`w-full absolute top-full`}
          style={{
            visibility: activeLineConfig.show ? "visible" : "hidden",
            transition: "all 0.2s ease-in-out",
          }}
        >
          <div
            id="mainViewContainer"
            className="view-area-width min-w-[80vw] scroll-hide mx-auto flex overflow-x-scroll h-[80vh] md:max-h-[500px] xl:max-h-fit"
            onMouseEnter={(e) => handleMouseEnter(e)}
            onMouseLeave={(e) => handleMouseLeave(e)}
          >
            {activeLineConfig.targetTab === "brands" && (
              <BrandHoverdTab
                id="brands-hovered-tab"
                style={{}}
                allBrands={brandStates?.allBrands}
                onClose={() => {
                  setActiveLineConfig((prev) => ({
                    ...prev,
                    show: false,
                  }));
                }}
              />
            )}
            {activeLineConfig.targetTab === "online-pharmacy" && (
              <OnlinePharmacyHoveredTab
                id="online-pharmacy-hovered-tab"
                style={{}}
                onClose={() => {
                  setActiveLineConfig((prev) => ({
                    ...prev,
                    show: false,
                  }));
                }}
                allMainCategory={allMainCategory}
                setAllMainCategory={setAllMainCategory}
                allSubCategory={allSubCategory}
                setAllSubCategory={setAllSubCategory}
                allChildCategory={allChildCategory}
                setAllChildCategory={setAllChildCategory}
                loader={loader}
                setLoader={setLoader}
                setActiveMainCategory={setActiveMainCategory}
                setActiveSubCategory={setActiveSubCategory}
                activeMainCategory={activeMainCategory}
                activeSubCategory={activeSubCategory}
              />
            )}
            {activeLineConfig.targetTab === "health-packages" && (
              <HealthPackageHoveredTab
                id="health-packages-hovered-tab"
                style={{}}
                data={healthPackages}
                setData={setHealthPackages}
                onClose={() => {
                  setActiveLineConfig((prev) => ({
                    ...prev,
                    show: false,
                  }));
                }}
              />
            )}
            {activeLineConfig.targetTab === "home-care" && (
              <HomeCareHoveredTab
                id="home-care-hovered-tab"
                style={{}}
                onClose={() => {
                  setActiveLineConfig((prev) => ({
                    ...prev,
                    show: false,
                  }));
                }}
                allCategories={allHomeCareCategories}
                categoryLoader={homeCareCategoryLoader}
                setAllCategories={setAllHomeCareCategories}
                setCategoryLoader={setHomeCareCategoryLoader}
              />
            )}
            {activeLineConfig.targetTab === "consult-a-doctor" && (
              <ConsultADoctorHoveredTab
                id="consult-a-doctor-hovered-tab"
                style={{}}
                onClose={() => {
                  setActiveLineConfig((prev) => ({
                    ...prev,
                    show: false,
                  }));
                }}
                allSpecialists={allSpecialists}
                specialistLoader={specialistLoader}
                setSpecialistLoader={setSpecialistLoader}
                setAllSpecialists={setAllSpecialists}
              />
            )}
            {activeLineConfig.targetTab === "lab-tests" && (
              <LabTestHoveredTab
                id="lab-tests-hovered-tab"
                style={{}}
                onClose={() => {
                  setActiveLineConfig((prev) => ({
                    ...prev,
                    show: false,
                  }));
                }}
                allTests={allTests}
                loader={allTestsLoader}
                setAllTests={setAllTests}
                setLoader={setAllTestsLoader}
              />
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default WebsiteHeader;
